import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import styles from './index.css'

class Chip extends PureComponent {
  render() {
    const { active, ariaLabel, children, className, value, ...props } = this.props

    return (
      <button
        {...props}
        aria-label={ariaLabel}
        className={cn(styles.button, active && styles.active, className)}
        type="button"
        value={value !== null && value !== undefined ? value : ariaLabel}
      >
        {children}
      </button>
    )
  }
}

Chip.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: ChildrenSchema.isRequired,

  active: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Chip
